<template>
  <div class="home">

    <!-- <div class="welcomeBox">

      <h1>{{ un }}</h1>      
    </div> -->
    <div class="tabsBox" id="contentBody" style="line-height:30px;">
      <el-tabs tab-position="top" type="border-card" style="background:transparent;width:90%;height: 100%;" stretch >
        <el-tab-pane style="overflow-y: auto;" >
                <span slot="label" ><i class="el-icon-date" style="margin-right:20px;"></i>金融同業新聞</span> 
                <el-table style="width: 100%" ref="multipleTable" :data="tableData"  :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}"  empty-text="暫無數據" >
                <!-- <el-table-column type="selection" width="50" ></el-table-column> -->
                <el-table-column prop="NewsTitle" label="新聞標題" min-width="30%">
                  <template slot-scope="scope">
                    <a class="goDetailPage" @click="goDetailPage(scope.row)">{{scope.row.NewsTitle }}</a>
                  </template>
                </el-table-column>
                <el-table-column prop="FinList" label="金融同業" min-width="30%">
                </el-table-column>                  
                <el-table-column prop="NewsTime" label="新聞時間" min-width="10%">
                  <template slot-scope="scope">
                    <div>{{ scope.row.NewsTime | moment("YYYY-MM-DD") }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="NewsSite" label="新聞網站" min-width="20%"></el-table-column>
                <el-table-column prop="NewsChannel" label="新聞頻道" min-width="10%"> </el-table-column>
              </el-table>
              <Pagination @currentChange="pageChange" :pageSize="Page_Size" :propsCurrentPage="Page_Num" :totalLists="totalLists" :maxPageLimit="50"> </Pagination>   
        </el-tab-pane>
        <el-tab-pane style="overflow-y: auto;"  >
              <span slot="label" ><i class="el-icon-reading" style="margin-right:20px;"></i>既有客戶新聞</span>
              <el-table style="width: 100%" ref="multipleTable" :data="tableData1"  :header-cell-style="{ background: '#FFF6EF', border: '1px #ddd solid', textAlign: 'center'}"  empty-text="暫無數據" >
                <!-- <el-table-column type="selection" width="50" ></el-table-column> -->
                <el-table-column prop="NewsTitle" label="新聞標題" min-width="30%" >
                  <template slot-scope="scope">
                    <a class="goDetailPage" @click="goDetailPage(scope.row)">{{scope.row.NewsTitle }}</a>
                  </template></el-table-column>
                  <el-table-column prop="TbbList" label="既有客戶"  min-width="30%">
                </el-table-column>                    
                <el-table-column prop="NewsTime" label="新聞時間" min-width="10%">
                  <template slot-scope="scope">
                    <div>{{ scope.row.NewsTime | moment("YYYY-MM-DD") }}</div>
                  </template>
                </el-table-column>
                <el-table-column prop="NewsSite" label="新聞網站" min-width="20%"></el-table-column>
                <el-table-column prop="NewsChannel" label="新聞頻道" min-width="10%"> </el-table-column>
              </el-table>
              <Pagination @currentChange="pageChange1" :pageSize="Page_Size1" :propsCurrentPage="Page_Num1" :totalLists="totalLists1" :maxPageLimit="50"> </Pagination>  
        </el-tab-pane>
      </el-tabs>
        
    </div>


  </div>
</template>
<script>
import Pagination from '../components/Pagination.vue';
import moment from "moment";


export default {
  components: {Pagination},
  data() {
    return {
      sAuthCode:"",
      start_date: moment().add(-3, "days").format("YYYY-MM-DD"),
      end_date:moment().format("YYYY-MM-DD"),
      Page_Size: 10,
      Page_Num: 1,
      Page_Size1: 10,
      Page_Num1: 1,      
      tableData: [],
      tableData1: [],
      totalLists: 0,
      totalLists1: 0,
      selectData: [],
      selectPage: [],
      un: this.$store.state.userInfo.UserName,
    };
  },
  computed: {},
  methods: {

    accMgt() {
      this.$router.push("/account-management");
    },
    authMgt() {
      this.$router.push("/auth-management");
    },

    showAll() {

    },

 

    goDetailPage(data) {
        console.log(data);
        let routeUrl = this.$router.resolve({
            path: "/detailNews",
            query: { id: data.DataID },                
        });
        window.open(routeUrl.href, "_blank");
    }, 

    async getList(isSys) {
      this.$store.dispatch("loadingHandler", true);
      this.tableData = [];

      let req = {Page_Size: this.Page_Size, Page_Num: this.Page_Num, Start_Date: this.start_date, End_Date: this.end_date, NewsType: 1 };     
      if ( !isSys ) 
        req.isSys = false;
      else 
        req.isSys = true;

      //console.log(req);

      await this.$api.apimgrs.searchNews(req).then((res)=>{

        
        this.tableData = res.data;
        this.totalLists = res.total;
        // console.log(this.tableData);        
      });


      this.$store.dispatch("loadingHandler", false);
    },

    async getList1(isSys) {
      this.$store.dispatch("loadingHandler", true);
      this.tableData1 = [];

      let req = {Page_Size: this.Page_Size, Page_Num: this.Page_Num1, Start_Date: this.start_date , End_Date: this.end_date, NewsType: 2 };     
      if ( !isSys ) 
        req.isSys = false;
      else 
        req.isSys = true;

      //console.log(req);

      await this.$api.apimgrs.searchNews(req).then((res)=>{

        
        this.tableData1 = res.data;
        this.totalLists1 = res.total;
        // console.log(this.tableData);        
      });


      this.$store.dispatch("loadingHandler", false);
    },    

    pageChange(val) {
      this.$store.dispatch("loadingHandler", true);
      // console.log('pageChange')
      this.Page_Num = val;
      this.getList(true);
      this.$store.dispatch("loadingHandler", false);
    },  
    pageChange1(val) {
      this.$store.dispatch("loadingHandler", true);
      // console.log('pageChange')
      this.Page_Num1 = val;
      this.getList1(true);
      this.$store.dispatch("loadingHandler", false);
    },  
  },
  async mounted() {
    // const start = Date.now();
    this.$store.dispatch("loadingHandler", true);
    //this.$store.loading = true;

    // console.log("sAuthCode", this.$route.query);
    // console.log("sAuthCode", this.$route.query.sAuthCode);
    this.sAuthCode = this.$route.query.sAuthCode;
    await this.getList(true);
    this.getList1(true);
    this.$store.dispatch("loadingHandler", false);
    // const millis = Date.now() - start;
    // console.log(`seconds elapsed = ${Math.floor(millis / 1000 )}`);
  },

};
</script>
<style lang="scss" scoped>
.home {
  height:150vh;
  // background: linear-gradient(-135deg, #00abb9 20%, #fff 50%, transparent 50%) center center / 100% 100%;
  // background-image: linear-gradient(to bottom,rgba(101,223,201,0.8) 25% ,#fff 80% , transparent 50% )
  // , url("./../assets/bg7.jpg");
  background-image: linear-gradient(to bottom,#FFF 55% ,#fff 80% , transparent 50% );
  background-size: cover;
  height: 100vh;

  .welcomeBox {
    margin: 0px 0px;
    padding: 20px 20px;
    display: flex;
    flex-direction: row;
    justify-content: center;

 
  }

  .tabsBox {
        display: flex;
        flex-direction: row;
        margin: 0px 0px;
        // padding: 20px 20px;  
        width: 100%;
        justify-content: center;
    }

    .goDetailPage {
      color: #0645ad;
      text-decoration: underline;
      cursor: pointer;
   } 

  .listBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin: 0px 0px;
    padding: 20px 5%;

    .functionButton {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      width: 80%;
      padding: 3% 13%;

      .el-button {
        width: 100%;
      }

    }


  }

  
}
::v-deep .yaxisTest{
    // font-size: 99px
    cursor: pointer;
  }
</style>
